import { CampaignModel } from "@/views/loyalty/models/campaign.model"

export default class AccountListViewModel {
  constructor (Campaign, AccountAccrual, AccountEmission) {
    this.Campaign = Campaign || new CampaignModel()
    this.AccountAccrual = AccountAccrual || { Account: '', Amount: 0 }
    this.AccountEmission = AccountEmission || { Account: '', Amount: 0 }
  }

  toCsv (delimiter) {
    const delim = delimiter || ";"
    return (
      this.Campaign.name +
      delim +
      this.Campaign.description +
      delim +
      this.AccountAccrual.Account +
      delim +
      this.AccountAccrual.Amount +
      delim +
      this.AccountEmission.Account +
      delim +
      this.AccountEmission.Amount +
      delim +
      "\n"
    )
  }
}
